import cloneDeep from 'lodash/cloneDeep'

const byThreshold = (a, b) =>
    Math.round(Number(a.minOrderValue) * 100) -
    Math.round(Number(b.minOrderValue) * 100)

class EodSpreadSettingFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        // only the writable fields; an existing tier keeps its @id for the in-place update,
        // a tier missing from the list is removed by the backend (orphanRemoval)
        return {
            spreadMax: parseInt(entity.spreadMax, 10),
            // task #168 (spec §12.5): the ready-by floor after a late acceptance, 0-60 minutes
            lateAcceptMinPrep: parseInt(entity.lateAcceptMinPrep, 10),
            // task ordit1/tasks/tasks#193: pre-order pickup gap, 0-120 minutes
            preorderPickupGap: parseInt(entity.preorderPickupGap, 10),
            tiers: (entity.tiers || [])
                .map((tier) => {
                    const row = {
                        minOrderValue: Number(tier.minOrderValue).toFixed(2),
                        spread: parseInt(tier.spread, 10),
                    }
                    if (tier['@id']) row['@id'] = tier['@id']
                    return row
                })
                .sort(byThreshold),
        }
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)

        values.tiers = (values.tiers || []).slice().sort(byThreshold)

        return values
    }
}

export default new EodSpreadSettingFormMapper()
